








import { Component, Vue } from 'vue-property-decorator'

@Component
export default class VideoHangup extends Vue {
  mounted() {
    const eventTypes = ['click', 'touchstart', 'keydown']

    let initialized = false

    const initializer = async () => {
      if (initialized) {
        return
      }

      initialized = true

      try {
        const audioElement = document.createElement('audio')
        const context = new (window.AudioContext || window.webkitAudioContext)()
        const source = context.createMediaElementSource(audioElement)

        audioElement.src = require('@/assets/sounds/mute.mp3')
        document.body.appendChild(audioElement)

        source.connect(context.destination)
        audioElement.muted = true
        await audioElement.play()
        audioElement.pause()

        document.body.removeChild(audioElement)

        eventTypes.forEach(type =>
          window.removeEventListener(type, initializer)
        )
      } catch (error) {
        console.error(error)
      }
    }

    eventTypes.forEach(type => window.addEventListener(type, initializer))
  }
}
